import React from 'react';
import { getConfig } from '../../../../utils/config';

function RewardClaimDescription() {
    const config = getConfig();
    return (
        <div className=" mx-auto py-4 px-6 2xl:px-8 mt-4 bg-gray-100 rounded-lg">
            <h2 className="text-lg font-semibold mb-4">How to Redeem</h2>
            <div className="flex overflow-x-auto scrollbar-hide space-x-2">
                <div className="flex-shrink-0 bg-white rounded-lg shadow-md p-4 w-[182px] h-[184px] lg:w-[200px] lg:h-[180px] 2xl:w-[222px]">
                    <div className="mb-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="50"
                            height="40"
                            viewBox="0 0 50 50"
                        >
                            <g id="g1035" transform="translate(0 682.665)">
                                <g id="g1037" transform="translate(0 -682.665)">
                                    <g id="g1039" clip-path="url(#clip-path)">
                                        <g
                                            id="g1045"
                                            transform="translate(13.763 52.686)"
                                        >
                                            <path
                                                id="path1047"
                                                d="M-269.463-3.689C-277.134-.567-291.1-6.942-290.753,8.5c8.112-5.262,17.588,2.262,22.477.166a3.879,3.879,0,0,0,1.124-.739c3.09-3.646,2.912-13.75-2.312-11.621"
                                                transform="translate(290.759 3.981)"
                                                fill="#9d9696"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                    </g>
                                </g>
                                <g id="g1049" transform="translate(0 -682.665)">
                                    <g id="g1051" clip-path="url(#clip-path)">
                                        <g
                                            id="g1057"
                                            transform="translate(39.256 1.172)"
                                        >
                                            <path
                                                id="path1059"
                                                d="M-37.095-74.128a2.93,2.93,0,0,0,2.932-2.928,2.931,2.931,0,0,0-2.932-2.931,2.931,2.931,0,0,0-2.932,2.931,2.93,2.93,0,0,0,2.932,2.928"
                                                transform="translate(40.027 79.986)"
                                                fill="#fe76a8"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1061"
                                            transform="translate(0.734 19.193)"
                                        >
                                            <path
                                                id="path1063"
                                                d="M-182.621-100.463l-3.409-5.231c-11.63-9.11-16.337,7.812-2.7,6.193Z"
                                                transform="translate(197.054 108.403)"
                                                fill="#fe76a8"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1065"
                                            transform="translate(13.369 11.765)"
                                        >
                                            <path
                                                id="path1067"
                                                d="M-86.04-128.3c8.548-10.746-8.323-15.641-6.687-.963l2.844,4.9Z"
                                                transform="translate(92.84 138.436)"
                                                fill="#fe76a8"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1069"
                                            transform="translate(9.372 19.989)"
                                        >
                                            <path
                                                id="path1071"
                                                d="M-15.876-91.5l4.784-.909,3.1-3.487-1-1.786a2.027,2.027,0,0,0-.77-.778,2.056,2.056,0,0,0-2.017-.014l-1.25.7-1.724.96-1.335.747a2.043,2.043,0,0,0-1.043,1.624,2.011,2.011,0,0,0,.25,1.159Z"
                                                transform="translate(17.131 98.736)"
                                                fill="#fece85"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1073"
                                            transform="translate(18.516 17.98)"
                                        >
                                            <path
                                                id="path1075"
                                                d="M-36.485-126.733l8.369-4.663a1.442,1.442,0,0,0,.557-1.954l-1.486-2.664A1.44,1.44,0,0,0-31-136.566l-6.716,3.743-1.653.92v3.487Z"
                                                transform="translate(39.368 136.748)"
                                                fill="#01d0fb"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1077"
                                            transform="translate(11.016 29.808)"
                                        >
                                            <path
                                                id="path1079"
                                                d="M-134.362-240.672l2.1-9.536-2.1-9.03h-4.3l-5.264-.454-1.054,3.976v13.176a1.874,1.874,0,0,0,1.869,1.869Z"
                                                transform="translate(144.981 259.693)"
                                                fill="#99e6fc"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1081"
                                            transform="translate(1.521 27.221)"
                                        >
                                            <path
                                                id="path1083"
                                                d="M-45.808-124.468l8.369-4.666.239-3.487-3.122-1.684-1.565.875-6.806,3.791a1.44,1.44,0,0,0-.554,1.951l1.486,2.666a1.444,1.444,0,0,0,1.954.554"
                                                transform="translate(49.428 134.305)"
                                                fill="#01d0fb"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1085"
                                            transform="translate(26.126 30.262)"
                                        >
                                            <path
                                                id="path1087"
                                                d="M-166.03-211.279v-15.653a1.05,1.05,0,0,0-1.045-1.045h-9.573l-2.5,9.286,2.5,9.28h8.75a1.874,1.874,0,0,0,1.869-1.869"
                                                transform="translate(179.152 227.977)"
                                                fill="#99e6fc"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1089"
                                            transform="translate(16.05 11.765)"
                                        >
                                            <path
                                                id="path1091"
                                                d="M-52.121-128.306c5.866-7.375-.242-12-4.119-9.422,3.2.179,5.963,4.007,2,9.51l.466.832Z"
                                                transform="translate(56.24 138.446)"
                                                fill="#fe5694"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1093"
                                            transform="translate(0.732 19.193)"
                                        >
                                            <path
                                                id="path1095"
                                                d="M-139.5-34.276c-6.636-5.2-11.016-1.922-11.025,1.55,1.381-2,4.6-2.95,8.968-.128a2.015,2.015,0,0,1,.722-.676Z"
                                                transform="translate(150.528 36.985)"
                                                fill="#fe5694"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1097"
                                            transform="translate(12.294 19.989)"
                                        >
                                            <path
                                                id="path1099"
                                                d="M-72.824-25.353l-.531-.954a2.027,2.027,0,0,0-.77-.778,2.056,2.056,0,0,0-2.017-.014l-1.25.7-1.187.662a2.056,2.056,0,0,1,2.017.014,2.047,2.047,0,0,1,.77.778l1,1.789,2.437-1.36Z"
                                                transform="translate(78.58 27.357)"
                                                fill="#fdb440"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1101"
                                            transform="translate(23.527 17.98)"
                                        >
                                            <path
                                                id="path1103"
                                                d="M-78.972-67.732a1.442,1.442,0,0,0,.557-1.954L-79.9-72.349a1.44,1.44,0,0,0-1.954-.554l-3.358,1.871a1.436,1.436,0,0,1,1.952.554l1.486,2.664a1.441,1.441,0,0,1-.548,1.951Z"
                                                transform="translate(85.213 73.084)"
                                                fill="#00b1cd"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1105"
                                            transform="translate(10.627 22.825)"
                                        >
                                            <path
                                                id="path1107"
                                                d="M-136.3-65.433l-2.883-5.171-7.889,4.4,2.883,5.171,7.889-4.4"
                                                transform="translate(147.076 70.604)"
                                                fill="#fe5694"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <path
                                            id="path1109"
                                            d="M302.38-269.489h-6.994v18.566h6.994Z"
                                            transform="translate(-273.751 299.751)"
                                            fill="#fe76a8"
                                            fill-rule="evenodd"
                                        />
                                        <g
                                            id="g1111"
                                            transform="translate(33.157 30.262)"
                                        >
                                            <path
                                                id="path1113"
                                                d="M-77.066-57.419v-3.493a1.05,1.05,0,0,0-1.045-1.045H-82.33a1.05,1.05,0,0,1,1.045,1.045V-45.26a1.876,1.876,0,0,1-1.872,1.869h4.221a1.874,1.874,0,0,0,1.869-1.869Z"
                                                transform="translate(83.157 61.957)"
                                                fill="#2ed1e2"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1115"
                                            transform="translate(21.635 30.262)"
                                        >
                                            <path
                                                id="path1117"
                                                d="M0-91.339v-7.219M0-79.991v-7.877M6.994-98.557v18.566"
                                                transform="translate(0 98.557)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1119"
                                            transform="translate(1.521 17.98)"
                                        >
                                            <path
                                                id="path1121"
                                                d="M-45.808-241.391l24.627-13.724a1.442,1.442,0,0,0,.557-1.954l-1.486-2.664a1.44,1.44,0,0,0-1.954-.554l-24.629,13.724a1.44,1.44,0,0,0-.554,1.951l1.486,2.666A1.444,1.444,0,0,0-45.808-241.391Z"
                                                transform="translate(49.428 260.468)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1123"
                                            transform="translate(10.627 22.825)"
                                        >
                                            <path
                                                id="path1125"
                                                d="M-99.819,0l2.883,5.171m-7.889,4.4L-107.708,4.4"
                                                transform="translate(107.708)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1127"
                                            transform="translate(0.734 19.193)"
                                        >
                                            <path
                                                id="path1129"
                                                d="M-105.375-112.644c-13.641,1.619-8.934-15.3,2.7-6.193"
                                                transform="translate(113.703 121.547)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1131"
                                            transform="translate(11.016 30.262)"
                                        >
                                            <path
                                                id="path1133"
                                                d="M-79.366,0h20.914a1.05,1.05,0,0,1,1.045,1.045V16.7a1.874,1.874,0,0,1-1.869,1.869H-83.769A1.874,1.874,0,0,1-85.638,16.7V3.521"
                                                transform="translate(85.638)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1135"
                                            transform="translate(9.372 19.989)"
                                        >
                                            <path
                                                id="path1137"
                                                d="M-15.878-91.509l7.889-4.4-1-1.786a2.054,2.054,0,0,0-2.787-.792l-4.309,2.4a2.049,2.049,0,0,0-.793,2.783Z"
                                                transform="translate(17.133 98.741)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1139"
                                            transform="translate(5.712 23.447)"
                                        >
                                            <path
                                                id="path1141"
                                                d="M-46.406-10.456a13.939,13.939,0,0,0-3.667-.826"
                                                transform="translate(50.073 11.283)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1143"
                                            transform="translate(13.369 11.764)"
                                        >
                                            <path
                                                id="path1145"
                                                d="M-13.718-31.118A10.953,10.953,0,0,0-14.69-24.4M-8-23.436c5.559-6.989.366-11.5-3.494-9.769"
                                                transform="translate(14.802 33.577)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1147"
                                            transform="translate(16.749 16.611)"
                                        >
                                            <path
                                                id="path1149"
                                                d="M0-46.173a9.52,9.52,0,0,1,1.224-3.649"
                                                transform="translate(0 49.823)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1151"
                                            transform="translate(33.859 13.042)"
                                        >
                                            <path
                                                id="path1153"
                                                d="M-30.194,0s1.011,9.337-2.386,13.02"
                                                transform="translate(32.58)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1155"
                                            transform="translate(41.282 7.842)"
                                        >
                                            <path
                                                id="path1157"
                                                d="M0-101.4s1.466-6.458,7.985-8.014"
                                                transform="translate(0 109.413)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1159"
                                            transform="translate(26.127 2.219)"
                                        >
                                            <path
                                                id="path1161"
                                                d="M-90.851-67.489l1.437-1.732c.3-.335.276-.434-.159-.542l-2.233-.554c-.253-.063-.267-.131-.392-.335l-1.128-1.883c-.227-.383-.366-.383-.6,0l-1.128,1.883c-.122.2-.139.273-.392.335l-2.233.554c-.432.108-.454.207-.159.542l1.44,1.732a.861.861,0,0,1,.156.662l-.173,2.141c-.048.443.046.5.46.329l1.963-.818a1.067,1.067,0,0,1,.727,0l1.966.818c.415.168.506.114.457-.329l-.171-2.141a.85.85,0,0,1,.156-.662"
                                                transform="translate(98.031 72.823)"
                                                fill="#fece85"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1163"
                                            transform="translate(28.95 2.353)"
                                        >
                                            <path
                                                id="path1165"
                                                d="M-21.1-43.191a11.558,11.558,0,0,1-1.668,4.609l1.222-.508a1.067,1.067,0,0,1,.727,0l1.966.818c.415.167.506.114.457-.329l-.17-2.141a.85.85,0,0,1,.156-.662l1.438-1.732c.3-.335.275-.434-.159-.542l-2.233-.554c-.253-.062-.267-.131-.392-.335l-1.128-1.883a1.434,1.434,0,0,0-.1-.153,13.246,13.246,0,0,1-.114,3.413"
                                                transform="translate(22.768 46.604)"
                                                fill="#fdb440"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1167"
                                            transform="translate(26.127 2.219)"
                                        >
                                            <path
                                                id="path1169"
                                                d="M-51.995-3.638l-1.128,1.883c-.122.2-.139.273-.392.335l-2.233.554c-.432.108-.454.207-.159.542l1.44,1.732a.861.861,0,0,1,.156.662l-.173,2.141c-.048.443.045.5.46.329l1.963-.818a1.067,1.067,0,0,1,.727,0l1.966.818c.415.167.506.114.457-.329l-.17-2.141a.85.85,0,0,1,.156-.662l1.437-1.732c.3-.335.276-.434-.159-.542l-2.233-.554c-.253-.062-.267-.131-.392-.335L-51.4-3.638C-51.625-4.022-51.765-4.022-51.995-3.638Z"
                                                transform="translate(56.104 3.926)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1171"
                                            transform="translate(40.451 19.056)"
                                        >
                                            <path
                                                id="path1173"
                                                d="M-90.842-67.489l1.437-1.732c.3-.335.276-.434-.159-.542l-2.233-.554c-.25-.063-.267-.131-.389-.335l-1.128-1.883c-.23-.383-.369-.383-.6,0l-1.131,1.883c-.122.2-.139.273-.389.335l-2.233.554c-.435.108-.457.207-.159.542l1.438,1.732a.85.85,0,0,1,.156.662l-.173,2.138c-.046.446.046.5.46.332l1.963-.818a1.075,1.075,0,0,1,.73,0l1.963.818c.415.168.506.114.46-.332L-91-66.828a.849.849,0,0,1,.156-.662"
                                                transform="translate(98.021 72.823)"
                                                fill="#fece85"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1175"
                                            transform="translate(43.273 19.187)"
                                        >
                                            <path
                                                id="path1177"
                                                d="M-21.135-43.226a11.558,11.558,0,0,1-1.67,4.609l1.221-.508a1.074,1.074,0,0,1,.73,0l1.963.818c.415.168.506.114.46-.332l-.173-2.138a.849.849,0,0,1,.156-.662l1.437-1.732c.3-.335.276-.434-.159-.542l-2.233-.554c-.25-.063-.267-.131-.389-.335l-1.128-1.883a1.35,1.35,0,0,0-.105-.156,13.251,13.251,0,0,1-.111,3.416"
                                                transform="translate(22.805 46.643)"
                                                fill="#fdb440"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1179"
                                            transform="translate(40.451 19.056)"
                                        >
                                            <path
                                                id="path1181"
                                                d="M-52.021-3.638l-1.131,1.883c-.122.2-.139.273-.389.335l-2.233.554c-.435.108-.457.207-.159.542L-54.5,1.408a.849.849,0,0,1,.156.662l-.173,2.138c-.046.446.045.5.46.332l1.963-.818a1.075,1.075,0,0,1,.73,0l1.963.818c.415.167.506.114.46-.332l-.173-2.138a.849.849,0,0,1,.156-.662l1.437-1.732c.3-.335.276-.434-.159-.542l-2.233-.554c-.25-.062-.267-.131-.389-.335l-1.128-1.883C-51.655-4.022-51.794-4.022-52.021-3.638Z"
                                                transform="translate(56.132 3.926)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                        <g
                                            id="g1183"
                                            transform="translate(40.722 1.172)"
                                        >
                                            <path
                                                id="path1185"
                                                d="M-55.644-37.081a2.931,2.931,0,0,0-2.932-2.931,2.916,2.916,0,0,0-1.466.392,2.925,2.925,0,0,1,1.466,2.539,2.923,2.923,0,0,1-1.466,2.536,2.915,2.915,0,0,0,1.466.392,2.93,2.93,0,0,0,2.932-2.928"
                                                transform="translate(60.041 40.012)"
                                                fill="#fe5694"
                                                fill-rule="evenodd"
                                            />
                                        </g>
                                        <g
                                            id="g1187"
                                            transform="translate(39.256 1.172)"
                                        >
                                            <path
                                                id="path1189"
                                                d="M-37.095-74.128a2.934,2.934,0,0,0,2.932-2.928,2.935,2.935,0,0,0-2.932-2.931,2.936,2.936,0,0,0-2.932,2.931A2.936,2.936,0,0,0-37.095-74.128Z"
                                                transform="translate(40.027 79.986)"
                                                fill="none"
                                                stroke="#000"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="1"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <h3 className="text-sm font-semibold">Create your gift basket</h3>
                    <p className="text-sm text-gray-600">
                        {`Select your favorite products and add to the cart​`} 
                    </p>
                </div>

                <div className="flex-shrink-0 flex items-center">
                    <svg
                        xmlns="
http://www.w3.org/2000/svg"
                        width="9.709"
                        height="17.068"
                        viewBox="0 0 9.709 17.068"
                    >
                        <g id="next" transform="translate(0.568 0.568)">
                            <g id="Group_11658" data-name="Group 11658">
                                <path
                                    id="Path_7346"
                                    data-name="Path 7346"
                                    d="M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z"
                                    transform="translate(-117.742 0)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="1"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="flex-shrink-0 bg-white rounded-lg shadow-md p-4  w-[182px] h-[184px] lg:w-[200px] lg:h-[180px] 2xl:w-[222px]">
                    <div className="mb-2">
                        <svg
                            xmlns="
http://www.w3.org/2000/svg"
                            width="31.788"
                            height="40"
                            viewBox="0 0 41.788 50"
                        >
                            <g
                                id="swipe-right"
                                transform="translate(-42.048 -0.004)"
                            >
                                <path
                                    id="Path_7347"
                                    data-name="Path 7347"
                                    d="M70.906,4.524,65.281.148a.684.684,0,0,0-.84,1.079l4.053,3.152H45.4a.684.684,0,0,0,0,1.368H68.493L64.441,8.9a.684.684,0,0,0,.84,1.08L70.906,5.6a.684.684,0,0,0,0-1.079Zm-16.6,39.489a10,10,0,0,1-6.467-7.362,22.051,22.051,0,0,1,.474-10.586.684.684,0,1,0-1.321-.354,23.414,23.414,0,0,0-.479,11.268,11.3,11.3,0,0,0,7.313,8.314.684.684,0,1,0,.482-1.279Zm0,0a10,10,0,0,1-6.467-7.362,22.051,22.051,0,0,1,.474-10.586.684.684,0,1,0-1.321-.354,23.414,23.414,0,0,0-.479,11.268,11.3,11.3,0,0,0,7.313,8.314.684.684,0,1,0,.482-1.279ZM81.76,5.025a4.16,4.16,0,0,0-5.672,1.521L70.1,16.918a4.153,4.153,0,0,0-7.544-.807l-.008.016A4.113,4.113,0,0,0,60.674,13.8,4.159,4.159,0,0,0,55,15.321l-.254.439a4.116,4.116,0,0,0-1.873-2.325,4.214,4.214,0,0,0-3.251-.4,3.949,3.949,0,0,0-2.43,1.939c-3.438,6.407-5.168,12.363-5.146,17.7a18.011,18.011,0,0,0,4.087,11.886,15.564,15.564,0,0,0,8.187,4.974A16.605,16.605,0,0,0,58.24,50a17.072,17.072,0,0,0,5.738-1,49.5,49.5,0,0,0,6.183-3.354c3.236-1.914,6.9-4.082,8.738-4.538a3.758,3.758,0,0,0,2.906-2.6,4.5,4.5,0,0,0-1.247-4.265,5.274,5.274,0,0,0-5.267-1.266l-5.767,1.544L83.283,10.7A4.16,4.16,0,0,0,81.76,5.025Zm.338,4.989L67.516,35.267a.684.684,0,0,0,.769,1l7.36-1.971a3.944,3.944,0,0,1,3.94.9,3.118,3.118,0,0,1,.9,2.935,2.417,2.417,0,0,1-1.919,1.646c-2.03.5-5.627,2.631-9.1,4.688a50.694,50.694,0,0,1-5.946,3.243,14.978,14.978,0,0,1-16.347-4.044c-5.41-6.287-4.963-16.511,1.227-28.052A2.593,2.593,0,0,1,50,14.35a2.843,2.843,0,0,1,2.192.269,2.8,2.8,0,0,1,1.054,3.747l-1.007,1.743a.684.684,0,1,0,1.184.685l.975-1.687.04-.07L56.185,16a2.785,2.785,0,0,1,4.823,2.784l-2.656,4.6-.007.012a.684.684,0,0,0,1.185.684L63.74,16.8A2.785,2.785,0,1,1,68.6,19.509l-4.348,7.531a.684.684,0,1,0,1.184.684l4.308-7.457.051-.091L77.273,7.23A2.785,2.785,0,1,1,82.1,10.014Zm-27.789,34a10,10,0,0,1-6.467-7.362,22.051,22.051,0,0,1,.474-10.586.684.684,0,1,0-1.321-.354,23.414,23.414,0,0,0-.479,11.268,11.3,11.3,0,0,0,7.313,8.314.684.684,0,1,0,.482-1.279Z"
                                />
                                <path
                                    id="Path_7348"
                                    data-name="Path 7348"
                                    d="M94.711,63.905a2.785,2.785,0,1,0-4.825-2.784L82.41,74.067l-.051.091-4.308,7.457a.684.684,0,1,1-1.184-.684L81.216,73.4a2.785,2.785,0,1,0-4.864-2.714l-4.21,7.291a.684.684,0,0,1-1.185-.684l.007-.012,2.656-4.6A2.785,2.785,0,0,0,68.8,69.9l-1.75,3.032-.04.07-.975,1.687A.684.684,0,0,1,64.849,74l1.007-1.743A2.8,2.8,0,0,0,64.8,68.51a2.843,2.843,0,0,0-2.192-.269,2.593,2.593,0,0,0-1.6,1.269c-6.189,11.541-6.637,21.765-1.227,28.052a14.978,14.978,0,0,0,16.347,4.044,50.7,50.7,0,0,0,5.946-3.243c3.478-2.057,7.074-4.184,9.1-4.688A2.417,2.417,0,0,0,93.1,92.029a3.118,3.118,0,0,0-.9-2.935,3.944,3.944,0,0,0-3.94-.9L80.9,90.16a.684.684,0,0,1-.769-1ZM67.321,98.783a.684.684,0,0,1-.881.4,11.3,11.3,0,0,1-7.313-8.314A23.414,23.414,0,0,1,59.607,79.6a.684.684,0,1,1,1.321.354,22.051,22.051,0,0,0-.474,10.586A10,10,0,0,0,66.922,97.9a.683.683,0,0,1,.4.88Z"
                                    transform="translate(-12.613 -53.891)"
                                    fill="#ffddce"
                                />
                            </g>
                        </svg>
                    </div>
                    <h3 className="text-sm font-semibold">Redeem Now</h3>
                    <p className="text-sm text-gray-600">
                        {`Confirm items in  your cart and initiate the redemption process. ​`}
                         
                    </p>
                </div>

                <div className="flex-shrink-0 flex items-center">
                    <svg
                        xmlns="
http://www.w3.org/2000/svg"
                        width="9.709"
                        height="17.068"
                        viewBox="0 0 9.709 17.068"
                    >
                        <g id="next" transform="translate(0.568 0.568)">
                            <g id="Group_11658" data-name="Group 11658">
                                <path
                                    id="Path_7346"
                                    data-name="Path 7346"
                                    d="M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z"
                                    transform="translate(-117.742 0)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="1"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="flex-shrink-0 bg-white rounded-lg shadow-md p-4  w-[182px] h-[184px] lg:w-[200px] lg:h-[180px] 2xl:w-[222px]">
                    <div className="mb-2">
                        <svg
                            xmlns="
http://www.w3.org/2000/svg"
                            width="57"
                            height="39.795"
                            viewBox="0 0 57 39.795"
                        >
                            <g
                                id="fast-delivery"
                                transform="translate(0 -80.164)"
                            >
                                <path
                                    id="Path_7349"
                                    data-name="Path 7349"
                                    d="M344.076,211.863l-3.018-2.157-.041-8.5a1.287,1.287,0,0,0-1.37-1.315H330.3l-5.739,21.418h16.063a2.5,2.5,0,0,0,2.263-1.785l1.642-6.129A1.374,1.374,0,0,0,344.076,211.863Z"
                                    transform="translate(-288.431 -106.396)"
                                    fill="#ffa95f"
                                />
                                <path
                                    id="Path_7350"
                                    data-name="Path 7350"
                                    d="M330.4,332.61a.494.494,0,0,1-.4-.152.6.6,0,0,1-.047-.51l1.018-3.8h-4.493l-1.913,7.139h16.063a2.5,2.5,0,0,0,2.263-1.785l.239-.892Z"
                                    transform="translate(-288.431 -220.377)"
                                    fill="#ff8b5a"
                                />
                                <path
                                    id="Path_7351"
                                    data-name="Path 7351"
                                    d="M395.216,211.863l-3.018-2.157-.041-8.5a1.287,1.287,0,0,0-1.37-1.315h-4.852l-3.826,14.279h13.355l.208-.774a1.374,1.374,0,0,0-.456-1.53Z"
                                    transform="translate(-339.571 -106.396)"
                                    fill="#ffc269"
                                />
                                <path
                                    id="Path_7352"
                                    data-name="Path 7352"
                                    d="M108.878,183.858h24.988a.662.662,0,0,1,.653.892l-5.978,22.31h-25.88a.662.662,0,0,1-.653-.892l5.739-21.418A1.248,1.248,0,0,1,108.878,183.858Z"
                                    transform="translate(-90.624 -92.15)"
                                    fill="#e5646e"
                                />
                                <path
                                    id="Path_7353"
                                    data-name="Path 7353"
                                    d="M128.54,207.06l.717-2.677H106.334a.875.875,0,0,1-.845-1.1l.7-2.614a.881.881,0,0,1,1.14-.594,14.975,14.975,0,0,0,5.65.707c7-.455,12.6-5.924,13.934-12.816a12.032,12.032,0,0,0,.121-4.108H108.877a1.248,1.248,0,0,0-1.132.892l-5.739,21.418a.662.662,0,0,0,.653.892h25.88Z"
                                    transform="translate(-90.623 -92.149)"
                                    fill="#db4655"
                                />
                                <ellipse
                                    id="Ellipse_1802"
                                    data-name="Ellipse 1802"
                                    cx="4.08"
                                    cy="3.123"
                                    rx="4.08"
                                    ry="3.123"
                                    transform="matrix(0.753, -0.659, 0.659, 0.753, 42.646, 115.241)"
                                    fill="#5d5360"
                                />
                                <ellipse
                                    id="Ellipse_1803"
                                    data-name="Ellipse 1803"
                                    cx="4.08"
                                    cy="3.123"
                                    rx="4.08"
                                    ry="3.123"
                                    transform="matrix(0.753, -0.659, 0.659, 0.753, 14.97, 115.255)"
                                    fill="#5d5360"
                                />
                                <path
                                    id="Path_7354"
                                    data-name="Path 7354"
                                    d="M405.681,238.2h6.247l-.03-6.247h-4.543a2.5,2.5,0,0,0-2.263,1.785l-.717,2.677A1.323,1.323,0,0,0,405.681,238.2Z"
                                    transform="translate(-359.3 -134.892)"
                                    fill="#dbeaff"
                                />
                                <circle
                                    id="Ellipse_1804"
                                    data-name="Ellipse 1804"
                                    cx="12.494"
                                    cy="12.494"
                                    r="12.494"
                                    transform="translate(8.867 80.999)"
                                    fill="#eceaec"
                                />
                                <circle
                                    id="Ellipse_1805"
                                    data-name="Ellipse 1805"
                                    cx="9.816"
                                    cy="9.816"
                                    r="9.816"
                                    transform="translate(11.544 83.676)"
                                    fill="#fff"
                                />
                                <circle
                                    id="Ellipse_1806"
                                    data-name="Ellipse 1806"
                                    cx="1.785"
                                    cy="1.785"
                                    r="1.785"
                                    transform="translate(19.576 91.708)"
                                    fill="#5d5360"
                                />
                                <path
                                    id="Path_7355"
                                    data-name="Path 7355"
                                    d="M411.927,238.2l-.013-2.677h-3.971a.493.493,0,0,1-.4-.152.6.6,0,0,1-.047-.51l.717-2.677.062-.231h-.924a2.5,2.5,0,0,0-2.263,1.785l-.717,2.677a1.323,1.323,0,0,0,1.307,1.785h6.247Z"
                                    transform="translate(-359.3 -134.892)"
                                    fill="#c3ddff"
                                />
                                <path
                                    id="Path_7356"
                                    data-name="Path 7356"
                                    d="M422.109,384.777a.835.835,0,0,0,0,1.67h.009a.835.835,0,1,0-.009-1.67Z"
                                    transform="translate(-374.375 -270.701)"
                                />
                                <path
                                    id="Path_7357"
                                    data-name="Path 7357"
                                    d="M173.609,384.777a.835.835,0,1,0,0,1.67h.009a.835.835,0,0,0-.009-1.67Z"
                                    transform="translate(-153.54 -270.701)"
                                />
                                <path
                                    id="Path_7358"
                                    data-name="Path 7358"
                                    d="M140.091,190.272l-2.67-1.909-.039-8.074a2.111,2.111,0,0,0-2.2-2.146H128.7a1.537,1.537,0,0,0-.278-1.208,1.511,1.511,0,0,0-1.215-.577h-5.819a.835.835,0,1,0,0,1.67h5.623l-5.77,21.533h-12.68a3.4,3.4,0,0,0-3.571-3.57,5.81,5.81,0,0,0-5.123,3.57h-3.67l1.631-6.088a.835.835,0,0,0-1.613-.432l-1.674,6.247a1.56,1.56,0,0,0,.245,1.366,1.511,1.511,0,0,0,1.215.577h3.5a3.4,3.4,0,0,0,3.571,3.57,5.81,5.81,0,0,0,5.123-3.57h18.972a3.4,3.4,0,0,0,3.571,3.57,5.811,5.811,0,0,0,5.123-3.57h.3a3.335,3.335,0,0,0,3.07-2.4l1.642-6.129a2.2,2.2,0,0,0-.777-2.426Zm-33.3,9.907a4.177,4.177,0,0,1-3.72,2.951,1.886,1.886,0,0,1-1.549-.675,2.084,2.084,0,0,1-.258-1.843,4.177,4.177,0,0,1,3.72-2.951,1.886,1.886,0,0,1,1.549.675A2.085,2.085,0,0,1,106.793,200.179Zm28.956-12.22h-5.408a.547.547,0,0,1-.443-.174.651.651,0,0,1-.057-.56l.717-2.677a1.666,1.666,0,0,1,1.456-1.166h3.712Zm-1.291,12.22a4.177,4.177,0,0,1-3.72,2.951,1.886,1.886,0,0,1-1.549-.675,2.084,2.084,0,0,1-.258-1.843,4.177,4.177,0,0,1,3.72-2.951,1.886,1.886,0,0,1,1.549.675A2.085,2.085,0,0,1,134.457,200.179Zm3.155-1.785a1.68,1.68,0,0,1-1.391,1.162,3.4,3.4,0,0,0-3.571-3.566,5.81,5.81,0,0,0-5.123,3.57h-4.562l1.465-5.469H134.5a.835.835,0,0,0,0-1.67h-9.621l3.378-12.609h6.92c.243,0,.533.084.535.484l.007,1.416h-3.7a3.335,3.335,0,0,0-3.07,2.4l-.717,2.677a2.292,2.292,0,0,0,.345,2.008,2.194,2.194,0,0,0,1.768.828h5.979l2.8,2c.238.17.164.529.135.635l-.042.155h-1.144a.835.835,0,0,0,0,1.67h.7Z"
                                    transform="translate(-83.96 -85.485)"
                                />
                                <path
                                    id="Path_7359"
                                    data-name="Path 7359"
                                    d="M85.474,106.821A13.329,13.329,0,1,0,72.145,93.493,13.344,13.344,0,0,0,85.474,106.821Zm0-24.988A11.659,11.659,0,1,1,73.815,93.493,11.672,11.672,0,0,1,85.474,81.834Z"
                                    transform="translate(-64.113)"
                                />
                                <path
                                    id="Path_7360"
                                    data-name="Path 7360"
                                    d="M153.141,147.764a.832.832,0,0,0,.59-.245l1.814-1.814a2.618,2.618,0,0,0,3.51-3.51l4.492-4.492a.835.835,0,0,0-1.181-1.181l-4.492,4.492a2.618,2.618,0,0,0-3.51,3.51l-1.814,1.814a.835.835,0,0,0,.59,1.425Zm3.57-5.354a.95.95,0,1,1-.95.95A.951.951,0,0,1,156.711,142.41Z"
                                    transform="translate(-135.35 -49.867)"
                                />
                                <path
                                    id="Path_7361"
                                    data-name="Path 7361"
                                    d="M185.206,114.79a.835.835,0,0,0,.835-.835v-.892a.835.835,0,1,0-1.67,0v.892A.835.835,0,0,0,185.206,114.79Z"
                                    transform="translate(-163.846 -28.494)"
                                />
                                <path
                                    id="Path_7362"
                                    data-name="Path 7362"
                                    d="M185.206,264.535a.835.835,0,0,0-.835.835v.892a.835.835,0,0,0,1.67,0v-.892A.835.835,0,0,0,185.206,264.535Z"
                                    transform="translate(-163.846 -163.846)"
                                />
                                <path
                                    id="Path_7363"
                                    data-name="Path 7363"
                                    d="M257.351,194.06h.892a.835.835,0,1,0,0-1.67h-.892a.835.835,0,1,0,0,1.67Z"
                                    transform="translate(-227.959 -99.732)"
                                />
                                <path
                                    id="Path_7364"
                                    data-name="Path 7364"
                                    d="M106.772,193.225a.835.835,0,0,0-.835-.835h-.892a.835.835,0,0,0,0,1.67h.892A.835.835,0,0,0,106.772,193.225Z"
                                    transform="translate(-92.609 -99.732)"
                                />
                                <path
                                    id="Path_7365"
                                    data-name="Path 7365"
                                    d="M9.759,296.6H.835a.835.835,0,0,0,0,1.67H9.759a.835.835,0,0,0,0-1.67Z"
                                    transform="translate(0 -192.34)"
                                />
                                <path
                                    id="Path_7366"
                                    data-name="Path 7366"
                                    d="M30.237,328.664H24.883a.835.835,0,0,0,0,1.67h5.354a.835.835,0,0,0,0-1.67Z"
                                    transform="translate(-21.371 -220.835)"
                                />
                                <path
                                    id="Path_7367"
                                    data-name="Path 7367"
                                    d="M50.717,360.728H48.932a.835.835,0,0,0,0,1.67h1.785a.835.835,0,0,0,0-1.67Z"
                                    transform="translate(-42.743 -249.33)"
                                />
                            </g>
                        </svg>
                    </div>
                    <h3 className="text-sm font-semibold">Enter Shipping Details</h3>
                    <p className="text-sm text-gray-600">
                    Fill in your shipping address and contact details for delivery​
                    </p>
                </div>
                <div className="flex-shrink-0 flex items-center">
                    <svg
                        xmlns="
http://www.w3.org/2000/svg"
                        width="9.709"
                        height="17.068"
                        viewBox="0 0 9.709 17.068"
                    >
                        <g id="next" transform="translate(0.568 0.568)">
                            <g id="Group_11658" data-name="Group 11658">
                                <path
                                    id="Path_7346"
                                    data-name="Path 7346"
                                    d="M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z"
                                    transform="translate(-117.742 0)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="1"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="flex-shrink-0 bg-white rounded-lg shadow-md p-4  w-[182px] h-[184px] lg:w-[200px] lg:h-[180px] 2xl:w-[222px]">
                    <div className="mb-2">
                        <svg
                            xmlns="
http://www.w3.org/2000/svg"
                            width="25.807"
                            height="42.211"
                            viewBox="0 0 32.807 49.211"
                        >
                            <g
                                id="_19-Mobile"
                                data-name="19-Mobile"
                                transform="translate(-12 -2)"
                            >
                                <rect
                                    id="Rectangle_17267"
                                    data-name="Rectangle 17267"
                                    width="31"
                                    height="47"
                                    rx="4"
                                    transform="translate(13 3)"
                                    fill="#64b5f6"
                                />
                                <path
                                    id="Path_7368"
                                    data-name="Path 7368"
                                    d="M40.886,3h-4.1a3.281,3.281,0,0,1,3.281,3.281V44.829a3.281,3.281,0,0,1-3.281,3.281h-20.5A3.281,3.281,0,0,1,13,44.829V47.29a3.281,3.281,0,0,0,3.281,3.281H40.886a3.281,3.281,0,0,0,3.281-3.281V6.281A3.281,3.281,0,0,0,40.886,3Z"
                                    transform="translate(-0.18 -0.18)"
                                    fill="#42a5f5"
                                />
                                <path
                                    id="Path_7369"
                                    data-name="Path 7369"
                                    d="M44.167,6.281V44.009H13V6.281A3.28,3.28,0,0,1,16.281,3H40.886a3.28,3.28,0,0,1,3.281,3.281Z"
                                    transform="translate(-0.18 -0.18)"
                                    fill="#bbdefb"
                                />
                                <path
                                    id="Path_7370"
                                    data-name="Path 7370"
                                    d="M46.1,3H42a3.281,3.281,0,0,1,3.281,3.281V44.009h4.1V6.281A3.281,3.281,0,0,0,46.1,3Z"
                                    transform="translate(-5.395 -0.18)"
                                    fill="#90caf9"
                                />
                                <path
                                    id="Path_7371"
                                    data-name="Path 7371"
                                    d="M25,3H36.482V4.64a1.64,1.64,0,0,1-1.64,1.64h-8.2A1.64,1.64,0,0,1,25,4.64Z"
                                    transform="translate(-2.338 -0.18)"
                                    fill="#64b5f6"
                                />
                                <path
                                    id="Path_7372"
                                    data-name="Path 7372"
                                    d="M33.64,3V4.64A1.64,1.64,0,0,1,32,6.281h4.1a1.64,1.64,0,0,0,1.64-1.64V3Z"
                                    transform="translate(-3.596 -0.18)"
                                    fill="#42a5f5"
                                />
                                <path
                                    id="Path_7373"
                                    data-name="Path 7373"
                                    d="M30.2,13A12.55,12.55,0,0,1,22,16.281V21.2c0,7.733,8.2,10.662,8.2,10.662s8.2-2.929,8.2-10.662V16.281A12.55,12.55,0,0,1,30.2,13Z"
                                    transform="translate(-1.798 -1.978)"
                                    fill="#ffb74d"
                                />
                                <path
                                    id="Path_7374"
                                    data-name="Path 7374"
                                    d="M39.6,16.831v4.921c0,7.734-8.2,10.662-8.2,10.662a14.413,14.413,0,0,1-2.748-1.435c2.329-1.214,6.848-4.306,6.848-10.047V16.06a11.414,11.414,0,0,0,4.1.771Z"
                                    transform="translate(-2.994 -2.528)"
                                    fill="#ffa726"
                                />
                                <path
                                    id="Path_7375"
                                    data-name="Path 7375"
                                    d="M40.706,2H16.1A4.106,4.106,0,0,0,12,6.1V47.11a4.106,4.106,0,0,0,4.1,4.1H40.706a4.106,4.106,0,0,0,4.1-4.1V6.1a4.106,4.106,0,0,0-4.1-4.1ZM23.482,3.64h9.842v.82a.821.821,0,0,1-.82.82H24.3a.821.821,0,0,1-.82-.82Zm-7.382,0h5.741v.82A2.463,2.463,0,0,0,24.3,6.921h8.2a2.463,2.463,0,0,0,2.461-2.461V3.64h5.741A2.463,2.463,0,0,1,43.167,6.1V43.009H13.64V6.1A2.463,2.463,0,0,1,16.1,3.64ZM40.706,49.57H16.1A2.463,2.463,0,0,1,13.64,47.11V44.649H43.167V47.11A2.463,2.463,0,0,1,40.706,49.57ZM31.684,47.11a.82.82,0,0,1-.82.82H25.943a.82.82,0,1,1,0-1.64h4.921a.82.82,0,0,1,.82.82Zm-.74-11.182-.9.52.9.52a.82.82,0,1,1-.82,1.421l-.9-.52v1.04a.82.82,0,0,1-1.64,0v-1.04l-.9.52a.82.82,0,1,1-.82-1.421l.9-.52-.9-.52a.82.82,0,1,1,.82-1.421l.9.52v-1.04a.82.82,0,1,1,1.64,0v1.04l.9-.52a.82.82,0,1,1,.82,1.421Zm-13.284,1.04.9-.52-.9-.52a.82.82,0,0,1,.82-1.421l.9.52v-1.04a.82.82,0,1,1,1.64,0v1.04l.9-.52a.82.82,0,0,1,.82,1.421l-.9.52.9.52a.82.82,0,1,1-.82,1.421l-.9-.52v1.04a.82.82,0,0,1-1.64,0v-1.04l-.9.52a.82.82,0,1,1-.82-1.421Zm19.765-1.941.9-.52a.82.82,0,1,1,.82,1.421l-.9.52.9.52a.82.82,0,0,1-.82,1.421l-.9-.52v1.04a.82.82,0,0,1-1.64,0v-1.04l-.9.52a.82.82,0,1,1-.82-1.421l.9-.52-.9-.52a.82.82,0,1,1,.82-1.421l.9.52v-1.04a.82.82,0,1,1,1.64,0Zm-9.3-4.369a.816.816,0,0,0,.552,0c.087-.031,8.746-3.218,8.746-11.434V14.3a.82.82,0,0,0-.82-.82,11.832,11.832,0,0,1-7.623-3.041.822.822,0,0,0-1.158,0A11.829,11.829,0,0,1,20.2,13.482a.82.82,0,0,0-.82.82v4.921C19.382,27.44,28.04,30.627,28.128,30.658ZM21.022,15.095a13.426,13.426,0,0,0,7.382-2.98,13.426,13.426,0,0,0,7.382,2.98v4.129c0,6.365-5.988,9.207-7.382,9.782-1.393-.575-7.382-3.417-7.382-9.782Zm3.521,6.349a.82.82,0,1,1,1.16-1.16l1.881,1.881,4.341-4.341a.82.82,0,1,1,1.16,1.16L28.163,23.9a.82.82,0,0,1-1.16,0Z"
                                />
                            </g>
                        </svg>
                    </div>
                    <h3 className="text-sm font-semibold">
                        Confirm Redemption
                    </h3>
                    <p className="text-sm text-gray-600">
                        {`Enter the OTP to verify and complete the redemption process.​  `}
                    </p>
                </div>
                <div className="flex-shrink-0 flex items-center">
                    <svg
                        xmlns="
http://www.w3.org/2000/svg"
                        width="9.709"
                        height="17.068"
                        viewBox="0 0 9.709 17.068"
                    >
                        <g id="next" transform="translate(0.568 0.568)">
                            <g id="Group_11658" data-name="Group 11658">
                                <path
                                    id="Path_7346"
                                    data-name="Path 7346"
                                    d="M126.2,7.561,118.8.181a.62.62,0,1,0-.876.878L124.885,8l-6.96,6.941a.62.62,0,0,0,.876.878l7.4-7.38a.62.62,0,0,0,0-.878Z"
                                    transform="translate(-117.742 0)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="1"
                                />
                            </g>
                        </g>
                    </svg>
                </div>
                <div className="flex-shrink-0 bg-white rounded-lg shadow-md p-4  w-[182px] h-[184px] lg:w-[200px] lg:h-[180px] 2xl:w-[222px]">
                    <div className="mb-2">
                        <svg
                            xmlns="
http://www.w3.org/2000/svg"
                            width="39.343"
                            height="37.696"
                            viewBox="0 0 49.343 37.696"
                        >
                            <g
                                id="credit-card"
                                transform="translate(-7 -66.867)"
                            >
                                <g
                                    id="Group_11676"
                                    data-name="Group 11676"
                                    transform="translate(7.5 67.37)"
                                >
                                    <path
                                        id="Path_7376"
                                        data-name="Path 7376"
                                        d="M74.813,95.308,37.59,99.642A3.123,3.123,0,0,1,34.126,96.9L31.6,75.187a3.123,3.123,0,0,1,2.741-3.463l37.223-4.333a3.123,3.123,0,0,1,3.463,2.741l2.528,21.713A3.123,3.123,0,0,1,74.813,95.308Z"
                                        transform="translate(-29.236 -67.37)"
                                        fill="#ffaa5a"
                                    />
                                    <path
                                        id="Path_7377"
                                        data-name="Path 7377"
                                        d="M103.068,92.223,100.54,70.509a3.116,3.116,0,0,0-2.674-2.721l2.7,23.221a2.275,2.275,0,0,1-2,2.523L59.841,98.041a3.116,3.116,0,0,0,3.263,1.978l37.223-4.333A3.123,3.123,0,0,0,103.068,92.223Z"
                                        transform="translate(-54.75 -67.747)"
                                        fill="#ff8b57"
                                    />
                                    <path
                                        id="Path_7378"
                                        data-name="Path 7378"
                                        d="M48.1,183.771H10.623A3.123,3.123,0,0,1,7.5,180.648v-21.86a3.123,3.123,0,0,1,3.123-3.123H48.1a3.123,3.123,0,0,1,3.123,3.123V169.4l-1.1,2.662,1.1,2.662v5.926A3.123,3.123,0,0,1,48.1,183.771Z"
                                        transform="translate(-7.5 -147.077)"
                                        fill="#b8eb7c"
                                    />
                                    <path
                                        id="Path_7379"
                                        data-name="Path 7379"
                                        d="M61.907,250.2H57.222a1.561,1.561,0,0,1-1.561-1.561V245.52a1.561,1.561,0,0,1,1.561-1.561h4.684a1.561,1.561,0,0,1,1.561,1.561v3.123A1.561,1.561,0,0,1,61.907,250.2Z"
                                        transform="translate(-50.977 -226.783)"
                                        fill="#ffefac"
                                    />
                                    <path
                                        id="Path_7380"
                                        data-name="Path 7380"
                                        d="M61.907,243.96h-.781v2.289a1.564,1.564,0,0,1-1.561,1.561h-3.9v.834a1.562,1.562,0,0,0,1.561,1.561h4.684a1.562,1.562,0,0,0,1.561-1.561v-3.123A1.562,1.562,0,0,0,61.907,243.96Z"
                                        transform="translate(-50.977 -226.784)"
                                        fill="#ffe077"
                                    />
                                    <path
                                        id="Path_7381"
                                        data-name="Path 7381"
                                        d="M49.9,156.8v23.311a2.342,2.342,0,0,1-2.342,2.342H8.635a3.116,3.116,0,0,0,3.013,2.342H49.122a3.123,3.123,0,0,0,3.123-3.123v-21.86A3.116,3.116,0,0,0,49.9,156.8Z"
                                        transform="translate(-8.525 -148.102)"
                                        fill="#98db7c"
                                    />
                                </g>
                                <g
                                    id="Group_11677"
                                    data-name="Group 11677"
                                    transform="translate(7.5 67.37)"
                                >
                                    <path
                                        id="Path_7382"
                                        data-name="Path 7382"
                                        d="M51.22,173.622v7.026a3.123,3.123,0,0,1-3.123,3.123H10.623A3.123,3.123,0,0,1,7.5,180.648v-21.86a3.123,3.123,0,0,1,3.123-3.123H48.1a3.123,3.123,0,0,1,3.123,3.123V170.5"
                                        transform="translate(-7.5 -147.077)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <path
                                        id="Path_7383"
                                        data-name="Path 7383"
                                        d="M38.972,72.835a3.112,3.112,0,0,1,2.043-1.109l37.223-4.335A3.123,3.123,0,0,1,81.7,70.132L84.23,91.846a3.123,3.123,0,0,1-2.741,3.463l-1.858.216"
                                        transform="translate(-35.911 -67.37)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <line
                                        id="Line_1332"
                                        data-name="Line 1332"
                                        x2="6.246"
                                        transform="translate(4.684 27.325)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <line
                                        id="Line_1333"
                                        data-name="Line 1333"
                                        x2="15.614"
                                        transform="translate(4.684 31.229)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <line
                                        id="Line_1334"
                                        data-name="Line 1334"
                                        x2="6.246"
                                        transform="translate(14.053 27.325)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <line
                                        id="Line_1335"
                                        data-name="Line 1335"
                                        x2="6.246"
                                        transform="translate(23.422 27.325)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <line
                                        id="Line_1336"
                                        data-name="Line 1336"
                                        x2="6.246"
                                        transform="translate(32.79 27.325)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <path
                                        id="Path_7384"
                                        data-name="Path 7384"
                                        d="M61.907,250.2H57.222a1.561,1.561,0,0,1-1.561-1.561V245.52a1.561,1.561,0,0,1,1.561-1.561h4.684a1.561,1.561,0,0,1,1.561,1.561v3.123A1.561,1.561,0,0,1,61.907,250.2Z"
                                        transform="translate(-50.977 -226.783)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <line
                                        id="Line_1337"
                                        data-name="Line 1337"
                                        x2="1.561"
                                        transform="translate(7.807 20.299)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <path
                                        id="Path_7385"
                                        data-name="Path 7385"
                                        d="M384.253,218.878a7.849,7.849,0,0,0,0-7.026"
                                        transform="translate(-347.609 -197.799)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <path
                                        id="Path_7386"
                                        data-name="Path 7386"
                                        d="M355.467,230.554a4.615,4.615,0,0,0,0-4.207"
                                        transform="translate(-321.622 -210.884)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                    <path
                                        id="Path_7387"
                                        data-name="Path 7387"
                                        d="M326.795,242.183a1.5,1.5,0,0,0,0-1.4"
                                        transform="translate(-295.739 -223.918)"
                                        fill="none"
                                        stroke="#000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="1"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                    <h3 className="text-sm font-semibold">Finalise Payment</h3>
                    <p className="text-sm text-gray-600">
                    Make the payment to confirm your order.​
                    </p>
                </div>
            </div>
        </div>
    );
}

export default RewardClaimDescription;
